<template>
  <div class="row two-block-image-container">
    <div class="col-xs-10 col-xs-push-1 col-sm-6 col-sm-push-3">
      <h1 v-if="imageBlockData.image_block_title" class="image-block-tittle">
        {{ imageBlockData.image_block_title }}
      </h1>
      <h4 v-if="imageBlockData.image_block_subtitle" class="image-block-sub-tittle">
        {{ imageBlockData.image_block_subtitle }}
      </h4>
      <div class="two-image-block">
        <img class="block-images" :src="blockImageOne.Src" :alt="blockImageOne.Alt" />
        <img class="block-images" :src="blockImageTwo.Src" :alt="blockImageTwo.Alt" />
      </div>
      <p class="block-text-description">{{ imageBlockData.image_block_description }}</p>
      <button
        v-if="ctaButton"
        class="cta-button-text ripple-animation ripple-animation--black"
        @click="redirectionCta()"
      >
        {{ ctaButton.Text }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'two-image-block',
  props: {
    imageBlockData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    blockImageOne() {
      return this.imageBlockData.image_block_Image1;
    },
    blockImageTwo() {
      return this.imageBlockData.image_block_Image2;
    },
    ctaButton() {
      const ctaBlock = this.imageBlockData.image_block_cta;
      if (ctaBlock && ctaBlock.Text) {
        return ctaBlock;
      } else {
        return null;
      }
    },
  },
  methods: {
    redirectionCta() {
      window.location.href = this.ctaButton.Url;
    },
  },
};
</script>
